import { Tag } from "antd";
import Overflow from "rc-overflow";
import K from "utilities/constants";
import styles from "./tagsCell.module.scss";

const renderTag = (item, color) => (
  <Tag color={color} className={styles.tagCell__tag}>
    <span className={styles.tagCell__text}>{item.name}</span>
  </Tag>
);

export const TagsCell = ({ items = [], color }) => {
  if (!items.length) return K.NullPlaceholder;

  const [first, ...rest] = items;

  return (
    <div className={styles.tagCell}>
      <div className={styles.tagCell__first}>{renderTag(first, color)}</div>
      {rest.length > 0 && (
        <Overflow
          className={styles.tagCell__overflow}
          data={rest}
          itemKey="id"
          maxCount="responsive"
          renderItem={(item) => renderTag(item, color)}
          renderRest={(omittedItems) => (
            <Tag color="#1b3799" className={styles.tagCell__more}>
              +{omittedItems.length}
            </Tag>
          )}
        />
      )}
    </div>
  );
};
